module.exports = __webpack_public_path__ + "img/arch-1.9295d326.jpg";